
import { prop, define } from "@/components/builder/utils";

import { HighlightPreview } from "../../utils/Highlight";

import { useConditional } from "./context";

function MultiConditionPreview({ children }) {
  useConditional()
  return <HighlightPreview>
    {children}
  </HighlightPreview>
}

function MultiConditionHTML({ children }) {
  return children.reverse().reduce((previous, children, idx, { length }) => <>
    {idx === length - 1 ? `{{#if ${children.props.condition}}}` : `{{else if ${children.props.condition}}}`}
    {children}
    {previous}
    {idx === length - 1 ? `{{/if}}` : null}
  </>, null)
}

export default define('multi-conditional', MultiConditionPreview, MultiConditionHTML)
  .name('multi condition')
  .state()
  .property(prop.toggle('Show case', 'show')
    .category('default')
    .props({ type: 'single' })
    .options(prop.options()
      .add('True', 'true')
      .add('False', 'false'))
    .ignoreDevice(true))
  .build()
